import React from 'react';
import IVButton from '@invideoio/web-shared/components/Button';

import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { toAppSigninUrl } from '@utils/app-signin';

interface CTAButtonComponentProps {
  CTAUrl: string;
  buttonText: string;
  className?: string;
  onClick?: () => void;
  noTopMargin?: boolean;
}

export const CTAButtonComponent: React.FC<CTAButtonComponentProps> = ({
  CTAUrl,
  buttonText,
  className,
  onClick,
  noTopMargin = false,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open(toAppSigninUrl(CTAUrl), '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={ivclass(noTopMargin ? '' : 'iv-pt-60 sm:iv-pt-30')}>
      <IVButton
        className={ivclass(
          'iv-flex',
          'iv-items-center',
          'iv-cursor-pointer',
          'iv-mx-auto',
          'iv-px-25 sm:iv-px-[14px]',
          'iv-h-52 sm:iv-h-28',
          'iv-border-2 iv-border-grey-85 hover:iv-border-grey-100 hover:iv-bg-grey-100 iv-transition',
          'iv-rounded-full sm:iv-rounded-m',
          'iv-text-grey-85 hover:iv-text-grey-0',
          'iv-text-body-2xl sm:iv-text-body-m',
          'iv-font-semibold',
          className,
        )}
        onClick={handleClick}
      >
        {buttonText}
      </IVButton>
    </div>
  );
};
